import React, {Component, RefObject} from 'react';
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonList,
  IonLoading,
  IonMenuButton,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar
} from '@ionic/react';
import './CalendarPage.css';
import CalendarItems from "../domain/CalendarItems";
import CalendarPageItem from "./components/CalendarPageItem";
import {RouteComponentProps} from "react-router";
import {actions, RootState} from "../store";
import {connect} from "react-redux";
import {PayloadMetaAction} from "typesafe-actions/dist/types";
import {PluginListenerHandle, Plugins} from "@capacitor/core";

type State = {
  isRefreshing: boolean;
  showLoading: boolean;
}

type Props = RouteComponentProps<{}> & typeof mapDispatchToProps & {
  updateCalendar: () => void;
  thisWeeksCalendarItems: CalendarItems;
  nextWeeksCalendarItems: CalendarItems;
  calendarItemsLastUpdate: Date;
};

export class CalendarPage extends Component<Props, State> {
  private ionRefresherRef: React.RefObject<HTMLIonRefresherElement>;
  private elementRef: RefObject<any>;
  private initialRendered: boolean = false;
  private backButtonHandle ?: PluginListenerHandle;

  constructor(props: Props) {
    super(props);
    this.state = {
      isRefreshing: false,
      showLoading: false,
    };
    props.removeContestDetail();
    props.updateCalendar();
    this.ionRefresherRef = React.createRef<HTMLIonRefresherElement>();
    this.elementRef = React.createRef();
  }

  checkIfMounted() {
    return this.elementRef.current != null;
  }

  componentDidMount(): void {
    setTimeout(() => {
      if (this.props.thisWeeksCalendarItems.isEmpty()) {
        this.setState({showLoading: true})
      }
    }, 150);
    this.backButtonHandle = Plugins.App.addListener('backButton', () => {
      Plugins.App.exitApp()
    });
  }
  componentWillUnmount(): void {
    this.backButtonHandle!.remove()
  }

  componentDidUpdate(prevProps: Readonly<RouteComponentProps<{}> & { updateCalendar: () => PayloadMetaAction<string, undefined, undefined>; removeContestDetail: () => PayloadMetaAction<string, undefined, undefined> } & { updateCalendar: () => void; thisWeeksCalendarItems: CalendarItems; nextWeeksCalendarItems: CalendarItems; calendarItemsLastUpdate: Date }>, prevState: Readonly<State>, snapshot?: any): void {
    [150, 500, 1500, 2500, 5000, 10000].forEach(timing => {
      setTimeout(() => {
        if (!this.props.thisWeeksCalendarItems.isEmpty() && this.state.showLoading) {
          if ((this.checkIfMounted() || !this.initialRendered) && document.readyState === "complete") {
            this.setState({showLoading: false});
            this.initialRendered = true;
          }
        }
        if (this.props.thisWeeksCalendarItems.isEmpty()) {
          if (!this.checkIfMounted() || !this.initialRendered) {
            this.setState({showLoading: true})
          }
        }
      }, timing);
    })
  }

  private renderLoading() {
    return (
      <IonContent>
        <IonLoading
          isOpen={this.state.showLoading}
          onDidDismiss={() => {
          }}
          message={'Loading...'}
          duration={3000}
        />
      </IonContent>
    );
  }

  render() {
    return (
      <>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton/>
            </IonButtons>
            <IonTitle>LRV digitaal - Wedstrijden</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <IonRefresher ref={this.ionRefresherRef} onIonRefresh={this.doRefresh}>
            <IonRefresherContent/>
          </IonRefresher>
          <div className="calendar-page-content">
            <h4>Wedstrijden</h4>
            {this.renderCalendar()}
            {this.renderLoading()}
          </div>
        </IonContent>
      </>
    );
  }

  doRefresh = () => {
    setTimeout(() => {
      this.setState(() => ({isRefreshing: true}));
      if (this.ionRefresherRef.current) {
        this.ionRefresherRef.current.complete();
      }
      this.props.updateCalendar();
    }, 500);
  };

  renderCalendar() {
    return (
      <>
        <IonList>
          <IonItemGroup key={"this-week"}>
            <IonItemDivider sticky>
              <IonLabel>
                Deze week
              </IonLabel>
            </IonItemDivider>
            {this.renderListItems(this.props.thisWeeksCalendarItems)}
          </IonItemGroup>
          <IonItemGroup key={"next-week"}>
            <IonItemDivider sticky>
              <IonLabel>
                Komende weken
              </IonLabel>
            </IonItemDivider>
            {this.renderListItems(this.props.nextWeeksCalendarItems)}
          </IonItemGroup>
        </IonList>
      </>
    );
  }

  private renderListItems(list: CalendarItems) {
    return list.map(item => <CalendarPageItem key={item.id} item={item} {...this.props}/>);
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    calendarItemsLastUpdate: state.calendar.lastUpdatedTimeStamp,
    thisWeeksCalendarItems: state.calendar.thisWeeksCalendarItems,
    nextWeeksCalendarItems: state.calendar.nextWeeksCalendarItems,
  }
};

const mapDispatchToProps = {
  updateCalendar: () => actions.calendaritems.updateCalendar(),
  removeContestDetail: () => actions.contest.removeContestDetail()
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CalendarPage);
